export default "__VITE_ASSET__BX0rA5MC__"